import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useGetLawFirmStatisticsQuery } from 'store/api/law-firms';
import LawFirmsStatisticsHeader from './LawFirmsStatisticsHeader';
import LawFirmsTable from './LawFirmsTable';

const LawFirmsPage = (): JSX.Element => {
    const { data: statistics, isLoading: isLoadingStats } = useGetLawFirmStatisticsQuery();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader hostsList titleId="law-firms.law-firms-hub" showBreadcrumb />
                <LawFirmsStatisticsHeader statistics={statistics} isLoading={isLoadingStats} />
                <LawFirmsTable />
            </div>
        </PaddedLayout>
    );
};

export default LawFirmsPage;
